import axios from 'axios';
import config from './config';

const METHODS = ['GET', 'DELETE', 'HEAD', 'POST', 'PUT', 'PATCH'];

const sidedRequest = opts => {
  // Strapi 5 returns a flattened response shape by default. This app reads the
  // legacy v4 shape (data.attributes.*), so request the v4 compatibility format.
  // Remove once consumers are migrated to the native v5 flat shape.
  const headers = { 'Strapi-Response-Format': 'v4' };

  if (opts.withToken) {
    headers.authorization = `bearer ${config.TOKEN}`;
  }
  return axios({ baseURL: `${config.API_URL}`, headers, ...opts });
};

const doRequest = opts => {
  return sidedRequest(opts);
};

const request = METHODS.reduce((req, method) => {
  req[method] = opts => doRequest({ ...opts, method });
  return req;
}, {});

export default request;
